import { isAxiosError } from "axios";

const BACKEND_OVERLOAD_STATUSES = new Set([503, 504]);

/**
 * These mean the backend is already saturated, so every retry adds load to the
 * thing that just failed. Queries retry 3 times by default and a request can
 * hang for the proxy's read timeout first, so one user action can hold server
 * capacity for many minutes.
 *
 * 502 is deliberately absent: nginx returns it when it cannot reach or read from
 * upstream, which is what a task being replaced during a rolling deploy looks
 * like. It fails in milliseconds rather than holding capacity, so retrying it is
 * both cheap and the case retries genuinely exist for.
 */
export function isBackendOverloadError(error: Error): boolean {
  return (
    isAxiosError(error) &&
    error.response !== undefined &&
    BACKEND_OVERLOAD_STATUSES.has(error.response.status)
  );
}
